var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._t("header-right")],2)]),_c('div',{staticClass:"card-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }